module.exports = __webpack_public_path__ + "img/tewi inaba_sc1.ccf0c960.png";